import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';


import { OwnFinancingActionTypes , OwnFinancingActions, LoadOwnFinancingsSuccess} from '../actions/own-financing.actions';
import { SummaryOwnFinancingModel } from '../../models/summary-own-financing.model';


export interface OwnFinancingState {
  items: SummaryOwnFinancingModel[];
  total: number;
  res: PaginableResponseModel<SummaryOwnFinancingModel>;
  selected: SingleResponseModel<SummaryOwnFinancingModel> | null;
  loading: boolean;
  error: any
}


export const initalState: OwnFinancingState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function OwnFinancingReducer(
  state = initalState,
  action: OwnFinancingActions
): OwnFinancingState {

  switch (action.type) {
    case OwnFinancingActionTypes.LoadOwnFinancings:
      return { ...state, loading: true, error: null };

    case OwnFinancingActionTypes.LoadOwnFinancingsSuccess:
      const { items, total } = (action as LoadOwnFinancingsSuccess).payload;
           return {
             ...state,
             loading: false,
             error: null,
             items: items,
             total: total,
           };
    case OwnFinancingActionTypes.LoadOwnFinancingsFailure:
      return{ ...state, loading: false, error: action.payload.error };


    case OwnFinancingActionTypes.LoadOwnFinancingSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
